export const redirectTo = (redirectUrl: string) => {
  window.open(redirectUrl, "_self")?.focus();
};
